module.exports = __webpack_public_path__ + "static/img/certificat_K.da88914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificat_K.png
// module id = Ajsy
// module chunks = 0